import {configureStore} from '@reduxjs/toolkit'
import { vmsApi } from './vmsApi'
import router from "./reducers/routerReducer";
import authSlice from "./reducers/authSlice";
import ui from "./reducers/uiReducer";


const store = configureStore({
  reducer: {
    router: router.reducer,
    auth: authSlice.reducer,
    ui: ui.reducer,
    [vmsApi.reducerPath]: vmsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: vmsApi,
      },
      immutableCheck: false,
      serializableCheck: false,
    }).concat(vmsApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store;
